import Phaser from "phaser";
import Scene3VM from "../ViewModels/Scene3ViewModel";
import { gameVM } from "../Game.jsx";
import GameflowHelper from "../Helpers/GameflowHelper";
import Loading from "./Loading";
import emitter from "../Events/EventManager";
import events from "../Events/Events";
import { dispatchChangeScene } from "../reducers/sceneReducer";
import { LEFT_EXIT, RIGHT_EXIT, LEFT_GO, RIGHT_GO, QUIT_GAME } from "../Events/Events";

import {
  dispatchDisableLeftClick,
  dispatchEnableLeftClick,
  dispatchDisableRightClick,
  dispatchEnableRightClick,
} from "../reducers/sceneReducer";

export default class Scene3 extends Phaser.Scene {
  gameJustStart;
  clickable;
  assetsLoaded;
  gameQuited;
  constructor() {
    super({ key: "Scene3" });

    this.Loading = new Loading(this);
    this.isFirstRound = true;
    this.clickable = true;
    this.gameQuited = false;
    this.assetsLoaded = false;
  }

  preload() {
    dispatchChangeScene("Scene3");
    this.clickable = true;
    this.gameQuited = false;
    this.Scene3VM = new Scene3VM(this);
    gameVM.latestScore = 0;
    this.Loading.progressBar();
    this.Scene3VM.proloadImageAssets();
  }

  async create() {
    gameVM.scene3 = this;
    this.sound.add("clickSound");
    this.sound.add("incorrectSound");
    this.sound.add("correctSound");
    this.sound.add("finishSound");
    this.initializeInterviewersIndex();
    this.Scene3VM.timeRemaining = gameVM.gameTotalTime;
    this.Scene3VM.score = 0;
    this.Scene3VM.currentQuestionIndex = 0;
    this.Scene3VM.addImageAssets();

    this.quitButton.on("pointerup", this.quitGame, this);

    this.Scene3VM.messageSetInvisible();
    this.timerStart();

    this.Scene3VM.showBoss();
    this.Scene3VM.showMessage("experience");
    this.Scene3VM.showDoorHint("experience");
    this.Scene3VM.closeLeftDoor();
    this.Scene3VM.closeRightDoor();
    this.Scene3VM.updateScoreText(gameVM.latestScore);
    this.leftCV.x += 20;
    emitter.on(LEFT_GO, () => {
      this.leftInterview.emit("pointerdown");
    });
    emitter.on(RIGHT_GO, () => {
      this.rightInterview.emit("pointerdown");
    });

    emitter.on(LEFT_EXIT, () => {
      this.leftExit.emit("pointerup");
    });
    emitter.on(RIGHT_EXIT, () => {
      this.rightExit.emit("pointerup");
    });

    emitter.on(QUIT_GAME, () => {
      this.quitButton.emit("pointerup");
    });

    this.leftInterview.on("pointerdown", this.leftInterviewOnClickHandler, this);
    this.rightInterview.on("pointerdown", this.rightInterviewOnClickHandler, this);

    this.leftExit.on("pointerup", this.leftExitOnClick, this);
    this.rightExit.on("pointerup", this.rightExitOnClick, this);

    //remove previously defined listeners:
    Object.values(events).forEach((key) => {
      emitter.removeListener(key);
    });

    emitter.on(events.addScore, () => {
      this.updateScoreCorrectAnswer();
    });
    emitter.on(events.minusScore, () => {
      this.updateScoreIncorrectAnswer();
    });

    await this.gameInitialization();
  }

  quitGame() {
    this.gameQuited = true;
    this.sound.play("clickSound");
    this.scene.sendToBack();
    this.scene.start("Scene1");
    this.isFirstRound = true;
    emitter.removeListener(events.addScore);
    emitter.removeListener(events.minusScore);

    gameVM.latestScore = 0;
    gameVM.timeRemaining = gameVM.gameTotalTime;
  }

  async gameInitialization() {
    this.initializeInterviewersIndex();

    this.Scene3VM.messageSetInvisible();
    this.Scene3VM.removeAllDoorIndicator();
    if (this.isFirstRound) {
      this.Scene3VM.updateInterviewers();
      this.Scene3VM.restoreInterviewers();
    }
    let currentQuestion = this.Scene3VM.currentQuestion.question;

    this.Scene3VM.showMessage(currentQuestion);

    this.Scene3VM.showDoorHint(currentQuestion);
    this.Scene3VM.dimDoorAsHint(currentQuestion);
    this.Scene3VM.stopInterviewerTweens();

    this.Scene3VM.showBoss();
    this.Scene3VM.showCVs();

    this.Scene3VM.updateInterviewers();
    this.Scene3VM.restoreInterviewers();
    this.enableAllDecisionButtons();
  }

  async leftExitOnClick() {
    dispatchDisableLeftClick();
    if (this.clickable) {
      this.clickable = false;
      this.sound.play("clickSound");
      this.disableDecisionButtons();
      this.Scene3VM.quitSceneToLeft(this.leftInterviewer);
      this.Scene3VM.closeLeftCV();

      if (this.Scene3VM.leftInterviewerIsSuitable()) {
        this.sound.play("incorrectSound");
        this.Scene3VM.showBoss("incorrectExit");
        this.Scene3VM.showMessage("incorrectExit");

        emitter.emit(events.minusScore);
      } else {
        this.sound.play("correctSound");
        this.Scene3VM.showBoss("incorrect");
        this.Scene3VM.showMessage("incorrect");
        emitter.emit(events.addScore);
      }

      this.Scene3VM.leftInterviewerHasBeenSelected = true;

      emitter.on(events.interviewerLeft, async () => {
        emitter.removeListener(events.interviewerLeft);
        await this.Scene3VM.Action(() => { }, 1500);
        if (this.gameQuited == false) {
          try {
            this.Scene3VM.closeDoors();
            this.rightInterview.setInteractive();
            this.rightExit.setInteractive();

            this.doGameRestart();
          } catch (err) {
            console.log(err);
          }
        }
      });
    }
  }

  async rightExitOnClick() {
    dispatchDisableRightClick();
    if (this.clickable) {
      this.clickable = false;
      this.sound.play("clickSound");
      this.disableDecisionButtons();

      this.Scene3VM.quitSceneToLeft(this.rightInterviewer);
      this.Scene3VM.closeRightCV();

      if (this.Scene3VM.rightInterviewerIsSuitable()) {
        this.sound.play("incorrectSound");
        this.Scene3VM.showBoss("incorrectExit");
        this.Scene3VM.showMessage("incorrectExit");
        emitter.emit(events.minusScore);
      } else {
        this.sound.play("correctSound");
        this.Scene3VM.showBoss("incorrect");
        this.Scene3VM.showMessage("incorrect");
        emitter.emit(events.addScore);
      }

      this.Scene3VM.rightInterviewerHasBeenSelected = true;

      emitter.on(events.interviewerLeft, async () => {
        emitter.removeListener(events.interviewerLeft);
        await this.Scene3VM.Action(() => { }, 1500);
        if (this.gameQuited == false) {
          try {
            this.Scene3VM.closeDoors();
            this.leftInterview.setInteractive();
            this.leftExit.setInteractive();
            this.doGameRestart();
          } catch (err) {
            console.log(err);
          }
        }
      });
    }
  }

  updateScoreIncorrectAnswer() {
    this.Scene3VM.minusScoreAnimation();
    this.Scene3VM.score = Math.max(this.Scene3VM.score - 10, 0);
    this.Scene3VM.updateScoreText(this.Scene3VM.score);
  }

  updateScoreCorrectAnswer() {
    this.Scene3VM.addScoreAnimation();
    this.Scene3VM.score = this.Scene3VM.score + 30;
    this.Scene3VM.updateScoreText(this.Scene3VM.score);
  }

  async leftInterviewOnClickHandler(pointer) {
    dispatchDisableLeftClick();
    if (this.clickable) {
      this.clickable = false;
      this.sound.play("clickSound");
      this.disableDecisionButtons();

      this.Scene3VM.leftInterviewerHasBeenSelected = true;
      this.Scene3VM.currentSelectedInterviewer = "left";

      if (this.Scene3VM.currentQuestion.question === "intern") {
        await this.Scene3VM.leftInterviewerGoLeft();
      } else {
        await this.Scene3VM.leftInterviewerGoRight();
      }
      // this.leftInterview.off("pointerdown", this.leftInterviewOnClickHandler, this);

      await this.bossResponse();

      emitter.on(events.interviewerLeft, async () => {
        emitter.removeListener(events.interviewerLeft);
        await this.Scene3VM.Action(() => { }, 500);
        if (this.gameQuited == false) {
          try {
            this.Scene3VM.closeDoors();
            this.rightInterview.setInteractive();
            this.rightExit.setInteractive();
            this.doGameRestart();
          } catch (err) {
            console.log(err);
          }
        }
      });
    }
  }

  async rightInterviewOnClickHandler(pointer) {
    dispatchDisableRightClick();
    if (this.clickable) {
      this.clickable = false;
      this.sound.play("clickSound");
      this.disableDecisionButtons();

      this.Scene3VM.rightInterviewerHasBeenSelected = true;
      this.Scene3VM.currentSelectedInterviewer = "right";

      if (this.Scene3VM.currentQuestion.question === "intern") {
        await this.Scene3VM.rightInterviewerGoLeft();
      } else {
        await this.Scene3VM.rightInterviewerGoRight();
      }
      // this.rightInterview.off("pointerdown", this.rightInterviewOnClickHandler, this);

      await this.bossResponse();
      if (this.gameQuited == false) {
        emitter.on(events.interviewerLeft, async () => {
          emitter.removeListener(events.interviewerLeft);

          await this.Scene3VM.Action(() => { }, 500);
          if (this.gameQuited == false) {
            try {
              this.Scene3VM.closeDoors();
              this.leftInterview.setInteractive();
              this.leftExit.setInteractive();
              this.doGameRestart();
            } catch (err) {
              console.log(err);
            }
          }
        });
      }
    }
  }

  async bossResponse() {
    if (this.Scene3VM.currentSelectedInterviewer === "left") {
      await this.Scene3VM.Action(() => { }, 100);

      if (this.Scene3VM.leftInterviewerIsSuitable()) {
        this.Scene3VM.openDoor();
        await GameflowHelper.action(() => { }, 100);
        if (this.gameQuited == false) {
          try {
            this.sound.play("correctSound");
            this.showDoorCorrectOrNotIndicator();
            this.Scene3VM.showBoss("correct");
            this.Scene3VM.showMessage("correct");
            emitter.emit(events.addScore);
          } catch (err) {
            console.log(err);
          }
        }
      } else {
        await GameflowHelper.action(() => { }, 100);
        if (this.gameQuited == false) {
          try {
            this.showDoorCorrectOrNotIndicator();
            this.Scene3VM.showBoss("incorrect");
            this.Scene3VM.showMessage("incorrect");
            this.sound.play("incorrectSound");
            emitter.emit(events.minusScore);
          } catch (err) {
            console.log(err);
          }
        }
      }
    }

    if (this.Scene3VM.currentSelectedInterviewer === "right") {
      await this.Scene3VM.Action(() => { }, 100);

      if (this.Scene3VM.rightInterviewerIsSuitable()) {
        this.Scene3VM.openDoor();
        await GameflowHelper.action(() => { }, 100);
        if (this.gameQuited == false) {
          try {
            console.log("is game quitted??", this.gameQuited);
            this.showDoorCorrectOrNotIndicator();
            this.sound.play("correctSound");
            this.Scene3VM.showBoss("correct");
            this.Scene3VM.showMessage("correct");
            this.updateScoreCorrectAnswer();
          } catch (err) {
            console.log(err);
          }
        }
      } else {
        await GameflowHelper.action(() => { }, 100);
        if (this.gameQuited == false) {
          try {
            console.log("is game quitted??", this.gameQuited);
            this.showDoorCorrectOrNotIndicator();
            this.sound.play("incorrectSound");
            this.Scene3VM.showBoss("incorrect");
            this.Scene3VM.showMessage("incorrect");
            this.updateScoreIncorrectAnswer();
          } catch (err) {
            console.log(err);
          }
        }
      }
    }
    await this.Scene3VM.Action(() => { }, 500);

    this.Scene3VM.fadeoutOrGoIn();
  }

  async showDoorCorrectOrNotIndicator() {
    if (this.Scene3VM.currentQuestion.question === "intern") {
      if (this.Scene3VM.currentSelectedInterviewer === "left") {
        if (this.Scene3VM.leftInterviewerIsSuitable()) {
          this.Scene3VM.showCorrectDoorIndicatorLHS();
        } else {
          this.Scene3VM.showIncorrectDoorIndicatorLHS();
        }
      }

      if (this.Scene3VM.currentSelectedInterviewer === "right") {
        if (this.Scene3VM.rightInterviewerIsSuitable()) {
          this.Scene3VM.showCorrectDoorIndicatorLHS();
        } else {
          this.Scene3VM.showIncorrectDoorIndicatorLHS();
        }
      }
    } else if (this.Scene3VM.currentQuestion.question === "experience") {
      if (this.Scene3VM.currentSelectedInterviewer === "left") {
        if (this.Scene3VM.leftInterviewerIsSuitable()) {
          this.Scene3VM.showCorrectDoorIndicatorRHS();
        } else {
          this.Scene3VM.showIncorrectDoorIndicatorRHS();
        }
      }

      if (this.Scene3VM.currentSelectedInterviewer === "right") {
        if (this.Scene3VM.rightInterviewerIsSuitable()) {
          this.Scene3VM.showCorrectDoorIndicatorRHS();
        } else {
          this.Scene3VM.showIncorrectDoorIndicatorRHS();
        }
      }
    }
  }

  initializeInterviewersIndex() {
    let randomPair = this.Scene3VM.getRandomPair(20);
    this.Scene3VM.currentLeftInterviewerIndex = randomPair[0];
    this.Scene3VM.currentRightInterviewerIndex = randomPair[1];
  }
  async doGameRestart() {
    console.log("restart now!!!!");
    this.enableAllDecisionButtons();

    if (
      this.Scene3VM.leftInterviewerHasBeenSelected == false ||
      this.Scene3VM.rightInterviewerHasBeenSelected == false
    ) {
      // if only one answer is chosen, the recruitor should ask for the type of employee again:
      let currentQuestion = this.Scene3VM.currentQuestion.question;
      await GameflowHelper.action(() => { }, 500);
      this.Scene3VM.showMessage(currentQuestion);
      this.Scene3VM.showBoss();
      this.clickable = true;
    }

    if (
      this.Scene3VM.leftInterviewerHasBeenSelected &&
      this.Scene3VM.rightInterviewerHasBeenSelected
    ) {
      this.Scene3VM.leftInterviewerHasBeenSelected = false;
      this.Scene3VM.rightInterviewerHasBeenSelected = false;
      dispatchEnableLeftClick();
      dispatchEnableRightClick();
      this.Scene3VM.currentQuestionIndex += 1;

      const nextQuestion = this.Scene3VM.questions[this.Scene3VM.currentQuestionIndex];

      if (nextQuestion) {
        this.Scene3VM.currentQuestion = nextQuestion;

        this.Scene3VM.removeCVText();
        this.Scene3VM.createCVText();

        this.gameInitialization();
      } else {
        this.Scene3VM.saveStateToGameVM();
        this.Scene3VM.startEndingScene();
      }
      this.clickable = true;
    }
  }

  timerStart() {
    this.time.addEvent({
      delay: 1000,
      callback: () => {
        this.Scene3VM.timeRemaining -= 1;
        this.Scene3VM.timeProgressbarSetProgress(
          this.Scene3VM.timeRemaining / gameVM.gameTotalTime
        );

        if (this.Scene3VM.timeRemaining === 0) {
          this.Scene3VM.saveStateToGameVM();
          this.Scene3VM.startEndingScene();
          this.gameQuited = true;
          this.isFirstRound = true;
        }
      },
      loop: true,
    });
  }

  disableDecisionButtons() {
    this.leftInterview.disableInteractive();
    this.leftExit.disableInteractive();
    this.rightInterview.disableInteractive();
    this.rightExit.disableInteractive();
  }

  enableAllDecisionButtons() {
    this.leftInterview.setInteractive();
    this.leftExit.setInteractive();
    this.rightInterview.setInteractive();
    this.rightExit.setInteractive();
  }
}
